import { StateCreator } from 'zustand'
import { type CampaignCreationState } from '../state'
import { initialState } from '../state'

export interface FormActionsSlice {
    resetForm: () => void
    submitCompanyData: () => Promise<void>
}

export const createFormActionsSlice: StateCreator<
    CampaignCreationState,
    [],
    [],
    FormActionsSlice
> = (set) => ({
    resetForm: () => set(initialState),
    submitCompanyData: async () => {
        console.log('Submitting company data...')
    },
})
